'use strict';

var EditLoadBalance = require('actionGroups/loadBalance/LoadBalance');

module.exports = {
  Model: EditLoadBalance,
};
